import { useAppSelector } from "@/hooks/store";
import { DisplaySize, useDisplay } from "@/utils/display";
import { useEffect } from "react";
export function useLayoutSize() {
    var size = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.displaySize;
    });
    var attachEvents = useDisplay().attachEvents;
    useEffect(function () {
        attachEvents();
    }, []);
    var displayIsSmall = size === DisplaySize.SMALL;
    var displayIsMedium = size === DisplaySize.MEDIUM;
    var displayIsLarge = size === DisplaySize.LARGE;
    var displayIsXLarge = size === DisplaySize.XLARGE;
    var displayIs2XLarge = size === DisplaySize.X2LARGE;
    var displayIsBelowSmall = displayIsSmall;
    var displayIsAboveSmall = !displayIsSmall;
    var displayIsBelowMedium = displayIsSmall || displayIsMedium;
    var displayIsAboveMedium = displayIsMedium || displayIsLarge || displayIsXLarge || displayIs2XLarge;
    var displayIsAboveLarge = displayIsLarge || displayIsXLarge || displayIs2XLarge;
    var displayIsBelowLarge = displayIsSmall || displayIsMedium;
    return {
        displayIsSmall: displayIsSmall,
        displayIsMedium: displayIsMedium,
        displayIsLarge: displayIsLarge,
        displayIsXLarge: displayIsXLarge,
        displayIs2XLarge: displayIs2XLarge,
        displayIsBelowSmall: displayIsBelowSmall,
        displayIsAboveSmall: displayIsAboveSmall,
        displayIsBelowMedium: displayIsBelowMedium,
        displayIsAboveMedium: displayIsAboveMedium,
        displayIsBelowLarge: displayIsBelowLarge,
        displayIsAboveLarge: displayIsAboveLarge,
    };
}
